export enum FirstRemindBefore {
  OneDay = 24,
  TwoDays = 48,
}